export default __webpack_public_path__ + "static/banner-480d5fb956ac80c2bc95cb7ed81fb191.png";